import styled from "styled-components";

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  background-color: ${props => props.theme.colors.white};
`;